import { render, staticRenderFns } from "./ProgFilmeComponent.vue?vue&type=template&id=39ebd64c&"
import script from "./ProgFilmeComponent.vue?vue&type=script&lang=js&"
export * from "./ProgFilmeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports